import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedUiDetailsModule} from '@snelstart/ui-details';
import {SharedUiFormControlsModule} from '@snelstart/ui-form-controls';
import {SharedUiButtonModule} from '@snelstart/ui-button';
import {SharedUiDialogModule} from '@snelstart/ui-dialog';
import {SharedUiListModule} from "@snelstart/ui-list";
import {SharedUiLoadingModule} from "@snelstart/ui-loading";
import {SharedUiOffCanvasModule} from "@snelstart/ui-off-canvas";
import {FeatureTaxWageDetailsComponent} from "./tax-wage-details/feature-tax-wage-details.component";
import {DomainLogicModule} from "@snelstart-ventures/fiscaal/domain-logic";
import {SharedUiTabModule} from "@snelstart/ui-tab";
import {DienstverbandComponent} from "./dienstverband/dienstverband.component";
import {SalarisstrookComponent} from "./salarisstrook/salarisstrook.component";
import {TekstWerknemerComponentenComponent} from "./tekst-werknemer-componenten/tekst-werknemer-componenten.component";
import { TekstDvDienstverbandComponent } from './tekst-werknemer-componenten/tekst-dv-dienstverband/tekst-dv-dienstverband.component';
import { TekstDvContractComponent } from './tekst-werknemer-componenten/tekst-dv-contract/tekst-dv-contract.component';
import { TekstDvWerkroosterComponent } from './tekst-werknemer-componenten/tekst-dv-werkrooster/tekst-dv-werkrooster.component';
import { TekstDvFiscaalComponent } from './tekst-werknemer-componenten/tekst-dv-fiscaal/tekst-dv-fiscaal.component';
import { TekstDvSvComponent } from './tekst-werknemer-componenten/tekst-dv-sv/tekst-dv-sv.component';
import { TekstVerloningComponent } from './tekst-werknemer-componenten/tekst-verloning/tekst-verloning.component';

@NgModule({
  imports: [
    CommonModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    SharedUiButtonModule,
    SharedUiDialogModule,
    SharedUiListModule,
    SharedUiLoadingModule,
    SharedUiOffCanvasModule,
    SalarisstrookComponent,
    DienstverbandComponent,
    DomainLogicModule,
    SharedUiTabModule,
    TekstWerknemerComponentenComponent,
    TekstDvDienstverbandComponent,
    TekstDvContractComponent,
    TekstDvWerkroosterComponent,
    TekstDvFiscaalComponent,
    TekstDvSvComponent,
    TekstVerloningComponent,
    FeatureTaxWageDetailsComponent
  ],
  declarations: [

  ],
  exports: [FeatureTaxWageDetailsComponent],
})
export class FeatureTaxWageDetailsModule {
}
